import { atom } from 'jotai'
import { ReactNode } from 'react'

import { ButtonProps } from '@/components/ui/button'

export interface ChatDialogConfig {
  title?: string
  description?: string
  content?: ReactNode
  confirmLabel?: string
  cancelLabel?: string
  onConfirm?: () => void
  onCancel?: () => void
  showCloseButton?: boolean
  buttonVariants?: {
    confirmButton?: ButtonProps['variant']
    cancelButton?: ButtonProps['variant']
  }
}

export const chatDialogAtom = atom<ChatDialogConfig | null>(null)

// Action atoms
export const openChatDialogAtom = atom(null, (_get, set, config: ChatDialogConfig) => {
  set(chatDialogAtom, config)
})

export const closeChatDialogAtom = atom(null, (_get, set) => {
  set(chatDialogAtom, null)
})
